import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { Stack, stepConnectorClasses, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';


// const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad', 'Create an ad group', 'Create an ad',, 'Create an ad group'];
//#4caf50

// const defaultSteps = [
//     'Submitted'
//   ];

//   const DefaultCustomStepIcon = (props:any) => {

//        return  <CheckCircleIcon style={{ color: '#4caf50' }} />



//   };

const CustomStepIcon = (props: any, rejectflag: boolean) => {
    const { active, completed } = props;

    if (rejectflag) {
        return <RadioButtonCheckedIcon style={{ color: '#fc0303' }} />
    }
    let iconColor = '#918e8e'; // Default color for the icon
    if (active) {
        return <RadioButtonCheckedIcon style={{ color: '#1976d2' }} />
    } else if (completed) {
        return <CheckCircleIcon style={{ color: '#4caf50' }} />
    }

    return (
        <RadioButtonUncheckedIcon style={{ color: iconColor }} />
    );
};




export const HorizontalStepper = (props: any) => {
    const [steps, setSteps] = useState<any[]>([]);


    useEffect(() => {

        if (props.workflowSteps != null) {
            setSteps(props.workflowSteps)
        }
    }, [props.workflowSteps]);


    const isStepFailed = (label: string) => {
        return label.includes('Rejected');
    };


    return (
        <div className='custom_steper'>
            <Box sx={{ width: '100%' }}>
                {steps.length != 0 && <Stepper activeStep={props.activeIndex} alternativeLabel>
                    {steps.map((label, index) => {
                        const labelProps: {
                            optional?: React.ReactNode;
                            error?: boolean;
                        } = {};
                        if (isStepFailed(label)) {
                            labelProps.error = true;
                        }

                        return (
                            <Step key={label}>
                                <StepLabel {...labelProps} StepIconComponent={(prop: any) => CustomStepIcon(prop, isStepFailed(label))}><Stack spacing={1} alignItems="center"> {/* Use Stack to position the label below the step circle */}
                                    <Typography variant="body2" align="center">{label}</Typography>
                                    {labelProps.optional}
                                </Stack></StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>}
                {/* {steps.length == 0 && 
      <Stepper activeStep={0} alternativeLabel>
        {defaultSteps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={DefaultCustomStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>} */}
            </Box>
        </div>
    );
}